const info={
    ZH: {  //中文翻译
        pleaseSelect:'请选择',
        pleaseInput:'请输入',
        title:'标题',
        query:'查询',
        reset:'重置',
        xh:'序号',
        operate:'操作',
        cancel: '取 消',
        yes: '确 定',
        view:'查看',
        edit:'编辑',
        appendix:'附件',
        chooseDocument:'选择文件',
        confirmUpload:'确认上传',
        format:'支持pdf, jpg, png, gif, rar, zip, doc, docx, xlsx, xls格式，大小不超过100M',
        noticeTitle:'公告标题',
        noticeContent:'公告内容',
        noticeType:'公告类型',
        noticeState:'公开状态',
        publisher:'发布人',
        add:'新增',
        publish:'发布',
        cancelPublish:'取消发布',
        delete:'删除',
        updateTime:'更新时间',
        publishTime:'发布时间',
    },
    EN: {  //英文翻译
        pleaseSelect:'please select',
        pleaseInput:'please input',
        title:'title',
        query: 'query',
        reset:'reset',
        xh:'no.',
        operate:'operate',
        cancel:'cancel',
        yes:'confirm',
        view:'view',
        edit:'edit',
        appendix:'appendix',
        chooseDocument:'choose document',
        confirmUpload: 'confirm upload',
        format: 'support format:pdf, jpg, png, gif, rar, zip, doc, docx, xlsx, xls, and size no more than 100M',
        noticeTitle: 'notice title',
        noticeContent: 'notice content',
        noticeType:'notice Type',
        noticeState:'notice state',
        publisher: 'publisher',
        add:'add',
        publish:'publish',
        cancelPublish:'cancel publish',
        delete:'delete',
        updateTime:'update time',
        publishTime: 'publish time',
    }
}
export default info  //需要暴露出去
